import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  map: null,
  course: null,
  isProcessFetching: false,
  isProcessFetchingCourse: false,
  isProcessEditMap: false,
  isProcessCreateMarker: false,
  isProcessEditMarker: false,
  isProcessRemoveMarker: false,
  isProcessMarkerId: '',
  error: '',
}

export default handleActions(
  {
    [actions.fetchMap]: state => {
      return {
        ...state,
        isProcessFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchMapSuccess]: (state, action) => {
      return {
        ...state,
        map: action.result,
        isProcessFetching: false,
        isProcessEditMap: false,
        isProcessMarkerId: '',
      }
    },
    [actions.fetchMapFailure]: (state, action) => {
      return {
        ...state,
        isProcessFetching: false,
        error: action.error,
      }
    },
    [actions.fetchCourse]: state => {
      return {
        ...state,
        isProcessFetchingCourse: true,
        error: initialState.error,
      }
    },
    [actions.fetchCourseSuccess]: (state, action) => {
      return {
        ...state,
        course: action.result,
        isProcessFetchingCourse: false,
      }
    },
    [actions.fetchCourseFailure]: (state, action) => {
      return {
        ...state,
        isProcessFetchingCourse: false,
        error: action.error,
      }
    },
    [actions.editMap]: state => {
      return {
        ...state,
        isProcessEditMap: true,
        error: initialState.error,
      }
    },
    [actions.editMapSuccess]: state => {
      return {
        ...state,
      }
    },
    [actions.editMapFailure]: (state, action) => {
      return {
        ...state,
        isProcessEditMap: false,
        error: action.error,
      }
    },
    [actions.createMarker]: state => {
      return {
        ...state,
        isProcessCreateMarker: true,
        error: initialState.error,
      }
    },
    [actions.createMarkerSuccess]: state => {
      return {
        ...state,
        isProcessCreateMarker: false,
      }
    },
    [actions.createMarkerFailure]: (state, action) => {
      return {
        ...state,
        isProcessCreateMarker: false,
        error: action.error,
      }
    },
    [actions.editMarker]: (state, action) => {
      return {
        ...state,
        isProcessMarkerId: action.marker_id,
        isProcessEditMarker: true,
        error: initialState.error,
      }
    },
    [actions.editMarkerSuccess]: state => {
      return {
        ...state,
        isProcessEditMarker: false,
      }
    },
    [actions.editMapFailure]: (state, action) => {
      return {
        ...state,
        isProcessMarkerId: '',
        isProcessEditMarker: false,
        error: action.error,
      }
    },
    [actions.removeMarker]: (state, action) => {
      return {
        ...state,
        isProcessMarkerId: action.marker_id,
        isProcessRemoveMarker: true,
        error: initialState.error,
      }
    },
    [actions.removeMarkerSuccess]: state => {
      return {
        ...state,
        isProcessMarkerId: '',
        isProcessRemoveMarker: false,
      }
    },
    [actions.removeMarkerFailure]: (state, action) => {
      return {
        ...state,
        isProcessMarkerId: '',
        isProcessRemoveMarker: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
